module.exports = __webpack_public_path__ + "static/media/ice23.b51d8bef.webp";